<template>
  <sdPageHeader :title="$t('pages.devPerms.detail')">
    <template v-slot:buttons>
      <div class="page-header-actions">
        <sdButton size="small" type="primary" :loading="buttonLoading" @click="save()">
          <sdFeatherIcons type="save" size="14" />
          {{ $t('common.save') }}
        </sdButton>
        <sdButton size="small" type="primary" @click="selectAll()">
          <sdFeatherIcons type="check" size="14" />
          {{ $t('pages.devPerms.select-all') }}
        </sdButton>
        <sdButton size="small" type="primary" @click="removeAll()">
          <sdFeatherIcons type="x" size="14" />
          {{ $t('pages.devPerms.remove-all') }}
        </sdButton>
      </div>
    </template>
  </sdPageHeader>
  <Main>
    <a-spin :spinning="isLoading">
      <a-card>
        <a-tree
          checkable
          :tree-data="treeData"
          v-model:expandedKeys="expandedKeys"
          v-model:selectedKeys="selectedKeys"
          v-model:checkedKeys="checkedKeys"
          :checkStrictly="true"
        >
          <template #title0010><span style="color: #1890ff">sss</span></template>
        </a-tree>
      </a-card>
    </a-spin>
  </Main>
</template>

<script>
import { Main } from '@/view/styled';

export default {
  name: 'devPermissions',
  components: {
    Main,
  },
  data() {
    return {
      group_id: this.$route.params.id,
      isLoading: true,
      buttonLoading: false,
      records: [],
      permissions: [],
      expandedKeys: [],
      selectedKeys: [],
      checkedKeys: [],
      treeData: [],
      all_ids: [],
    };
  },
  methods: {
    getMenus() {
      var _this = this;
      this.treeData = [];
      this.$appAxios.get(this.$endpoints.menu_tree_get).then((resp) => {
        if (resp.data.status) {
          _this.isLoading = false;
          _this.all_ids = resp.data.data.all_ids;
          var data = resp.data.data.records;
          data.forEach((menu) => {
            var childs = [];
            menu.childs.forEach((child) => {
              childs.push({
                title: _this.$store.state.i18n.i_lang == 'en' ? child.detail.en : child.detail.tr,
                key: child.id,
              });
            });

            _this.treeData.push({
              title: _this.$store.state.i18n.i_lang == 'en' ? menu.detail.en : menu.detail.tr,
              key: menu.id,
              children: childs,
            });
          });
        }
      });
    },
    save() {
      console.log(this.checkedKeys);
      // this.buttonLoading = true;
      const formData = {
        group_id: this.group_id,
        menu_ids: typeof this.checkedKeys.checked != 'undefined' ? this.checkedKeys.checked : this.checkedKeys,
      };
      this.$appAxios.post(this.$endpoints.menu_perms_set, formData).then((resp) => {
        if (resp.data.status) {
          this.$message.success(this.$t('common.success-message'));
        } else {
          this.$message.success(this.$t('common.error-message'));
        }
      });
    },
    getPermissions() {
      this.$appAxios.get(this.$endpoints.menu_perm_ids_get + '/' + this.group_id).then((resp) => {
        if (resp.data.status) {
          this.checkedKeys = resp.data.data;
          console.log('perms', this.checkedKeys);
        }
      });
    },
    selectAll() {
      this.checkedKeys = this.all_ids;
    },
    removeAll() {
      this.checkedKeys = [];
    },
  },
  created() {
    this.getMenus();
    this.getPermissions();
  },
};
</script>